import * as React from 'react';
type Props = {
  className?: string;
};
export function Instagram({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Instagram"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0333 2H7.96667C4.66667 2 2 4.66667 2 7.96667V16.0222V16.0333C2 19.3333 4.66667 22 7.96667 22H16.0222H16.0333C19.3333 22 22 19.3333 22 16.0333V7.96667C22 4.66667 19.3333 2 16.0333 2ZM19.8556 15.8C19.8556 18.0444 18.0444 19.8556 15.8 19.8556H8.2C5.95556 19.8556 4.14444 18.0444 4.14444 15.8V8.2V8.21111C4.14444 5.96667 5.95556 4.15556 8.2 4.15556H15.7889C18.0333 4.15556 19.8444 5.96667 19.8444 8.21111L19.8556 15.8ZM12 7C9.23333 7 7 9.23333 7 12C7 14.7667 9.23333 17 12 17C14.7667 17 17 14.7667 17 12C17 9.23333 14.7667 7 12 7ZM12 14.7111C10.5 14.7111 9.28889 13.5 9.28889 12C9.28889 10.5 10.5 9.28889 12 9.28889C13.5 9.28889 14.7111 10.5 14.7111 12C14.7111 13.5 13.5 14.7111 12 14.7111ZM18.3778 6.93333C18.3778 7.56667 17.8556 8.08889 17.2222 8.08889C16.5889 8.08889 16.0667 7.56667 16.0667 6.93333C16.0667 6.3 16.5889 5.77778 17.2222 5.77778C17.8556 5.77778 18.3778 6.3 18.3778 6.93333Z"
        fill="black"
      />
    </svg>
  );
}
